import type { GQL_ID } from '@@partner:types:graphql'
import type { Menu, MenuType } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface UpdateMenuInput {
  name?: string
  code?: string
  type?: MenuType
  is_active?: boolean
}

export interface UpdateMenuMutation {
  updateMenu: Menu
}

export interface UpdateMenuVariables {
  id: GQL_ID
  input: UpdateMenuInput
}

export const GQL_MUTATION_UPDATE_MENU = gql`
  mutation updateMenu($id: ID!, $input: UpdateMenuInput!) {
    updateMenu(id: $id, input: $input) {
      id
      name
      code
      type
      is_active
      created_at
      updated_at
    }
  }
`

export const useUpdateMenu = () =>
  useMutation<UpdateMenuMutation, UpdateMenuVariables>(GQL_MUTATION_UPDATE_MENU)
